import React from "react";
import intl from "react-intl-universal";


import type {CalendarTable} from "../../../screens/Lists/components/CalendarTable";
import {TaskReport} from "../../../../stores/taskLists/gql/serverTypes";


import {ImageGalleryPreview} from "../../../components/ImageGalleryPreview";
import {InfoBlockPlain} from "../../../components/InfoBlockRow/InfoBlockPlain";


export interface CantCompleteTaskProps {
    report: TaskReport;
    calendarTable: CalendarTable;
}

export const CantCompleteTask = (
    {
        calendarTable,
        report
    }: CantCompleteTaskProps
) => {
    const task = calendarTable.taskDs?.getTaskById(report.taskId);
    const taskName = task?.name;
    const taskListUnit = calendarTable.taskListUnitDS.getTaskListUnitById(report.taskListUnitId);
    const taskListName = Object.values(taskListUnit?.taskLists ?? {}).find(list => list.id === task?.taskListId)?.name ?? intl.get('taskList.ungrouped.short').d('Ungrouped Tasks');
    return (
        <div>
            <div className="title-large-bold TaskReportEdit__ContentBlock__taskName">{taskName}</div>
            <div className="body-medium TaskReportEdit__ContentBlock__tasklListName">{taskListName}</div>
            <div className="TaskReportComplete__ContentBlock">
                <div className="title-medium TaskReportEdit__ContentBlock__header">
                    {intl.get('taskReportEdit.cant-complete-task.header').d("Why wasn’t this task completed?")}
                </div>
                <div className={"TaskReportEdit__comment"}>
                    {report.comment}
                </div>
            </div>

            {report.commentImages && (
                <div className="TaskReportEdit__ContentBlock">
                    <div className="TaskReportEdit__Images">
                        <ImageGalleryPreview urls={report.commentImages}/>
                    </div>
                </div>
            )}
            <InfoBlockPlain
                className="TaskReportEdit__ContentBlock"
                createdBy={report.createdBy}
                createdAt={report.createdAt}
                updatedBy={report.updatedBy}
                updatedAt={report.updatedAt}
            />
        </div>
    );
};
